var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EBA177AA-3B9F-46B9-B8E3-FDF7DE33871A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.1970077,15.0535714 L11.1970077,17.9099421 L10.2312741,17.9099421 L10.2312741,15.0535714 L11.1970077,15.0535714 Z M6.07917145,13.8391861 L6.76183691,14.5218516 L5.12069603,16.1629925 L4.43803057,15.480327 L6.07917145,13.8391861 Z M15.3476575,13.8391122 L16.9885663,15.4804852 L16.3058043,16.1630541 L14.6648955,14.5216812 L15.3476575,13.8391122 Z M11.3887066,4.23909266 L13.2335907,4.56515444 C16.1739382,5.08465251 18.8429537,6.48909266 20.9522201,8.6261583 L21.2866795,8.96525097 L20.9522201,9.30434363 C18.9697876,11.3125483 16.4704633,12.6839768 13.7244208,13.2689189 L13.523166,12.3240347 C15.9266409,11.8120656 18.1277027,10.6540541 19.9175676,8.96496139 C18.3608108,7.49478764 16.5052124,6.43233591 14.4726834,5.84305019 C14.8638996,6.50530888 15.0758687,7.26660232 15.0758687,8.05888031 C15.0758687,10.4640927 13.1192085,12.4207529 10.7142857,12.4207529 C8.30936293,12.4207529 6.3527027,10.4640927 6.3527027,8.05888031 C6.3527027,7.26660232 6.56467181,6.50530888 6.95588803,5.84305019 C4.92335907,6.43233591 3.06805019,7.49478764 1.51100386,8.96496139 C3.3011583,10.6540541 5.5019305,11.8120656 7.90511583,12.3243243 L7.70415058,13.2692085 C4.95810811,12.6839768 2.45878378,11.3128378 0.476640927,9.30434363 L0.141891892,8.96525097 L0.476640927,8.6261583 C2.58590734,6.48880309 5.25492278,5.08465251 8.19527027,4.56515444 L10.0407336,4.23909266 L8.58272201,5.41621622 C7.77915058,6.06515444 7.31814672,7.02828185 7.31814672,8.05916988 C7.31814672,9.93185328 8.84189189,11.4555985 10.7142857,11.4555985 C12.5869691,11.4555985 14.1104247,9.93156371 14.1104247,8.05916988 C14.1104247,7.02828185 13.6497104,6.06515444 12.846139,5.41621622 L11.3887066,4.23909266 Z M10.7142857,6.80067568 C11.4124517,6.80067568 11.9805985,7.36853282 11.9805985,8.06669884 C11.9805985,8.76544402 11.4124517,9.33330116 10.7142857,9.33330116 C10.0158301,9.33330116 9.4476834,8.76515444 9.4476834,8.06669884 C9.4476834,7.36853282 10.0158301,6.80067568 10.7142857,6.80067568 Z M10.7142857,7.76611969 C10.5483591,7.76611969 10.4137066,7.90135135 10.4137066,8.06669884 C10.4137066,8.23233591 10.5483591,8.36785714 10.7142857,8.36785714 C10.8799228,8.36785714 11.0148649,8.23233591 11.0148649,8.06669884 C11.0148649,7.90135135 10.8799228,7.76611969 10.7142857,7.76611969 Z M5.12018172,1.7906195 L6.7613226,3.43176038 L6.07845237,4.1146306 L4.4373115,2.47348972 L5.12018172,1.7906195 Z M16.3076706,1.79038384 L16.9903361,2.47304931 L15.3489905,4.11439494 L14.666325,3.43172948 L16.3076706,1.79038384 Z M11.1970077,0.0434362934 L11.1970077,2.9003861 L10.2312741,2.9003861 L10.2312741,0.0434362934 L11.1970077,0.0434362934 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R3-Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R3-WebApp---Story-Review-(Static)",
    transform: "translate(-366.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(342.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-Bank",
    transform: "translate(24.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-App-Icon/-Creativity-Copy-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(4.285714, 5.357143)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#8688A1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.285714, -5.357143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.7d8d21f0c8eb254988870fde2a81305d.svg";
export { ForwardRef as ReactComponent };